export ModalForm from './ModalForm';
export Payments from './Payments';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/payment/containers/index.js